// src/components/Footer/Footer.js
import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <p>&copy; 2023 Habiba Shahidi. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;